import React from 'react';
import styles from './Success.module.scss';
import SuccessImg from '../Images/success.png';
import googleplay from '../Images/googleplay.svg';
import appstore from '../Images/appstore.svg';
import open from '../Images/open.svg';
import { useTranslation } from 'react-i18next';

interface SuccessProps {
  title: string;
  detail: string;
  buttonText: string;
  showClose: boolean;
  onClose: any;
}
const Success = (props: SuccessProps) => {
  const { t, i18n } = useTranslation();

  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  return (
    <div
      className={`${styles.Success} ${
        i18n.language === 'he' ? styles.heb : ''
      }`}
    >
      <img src={SuccessImg} className={styles.successImage} />
      <div className={styles.title}>{props.title}</div>
      <div className={`${styles.text} pl-2 pr-2`}>{props.detail}</div>
      <div className={styles.images}>
        <a href="http://kre8.tv/ios" target="_blank">
          <img src={appstore} />
        </a>
        <a href="http://kre8.tv/android" target="_blank">
          <img src={googleplay} />
        </a>
      </div>
      <a
        href={
          getMobileOperatingSystem() === 'Android'
            ? 'http://kre8.tv/android'
            : 'http://kre8.tv/ios'
        }
        target="_blank"
      >
        <div className={`${styles.downloadMobile} mt-4`}>
          <span>
            {props.buttonText ? props.buttonText : t('modal_success_open')}
          </span>
          <img src={open} />
        </div>
      </a>
      {props.showClose === true ? (
        <div
          onClick={() => props.onClose()}
          className={`${styles.maybeLater} mt-4`}
        >
          <span>{t('no_thanks_maybe_later')}</span>
        </div>
      ) : null}
    </div>
  );
};
export default Success;
